export const COMPANY = {
  brand: "GOOX",
  domain: "goox.vip",
  legalName: "CAP GROUP S.A.S.",
  nit: "901638339-9",
  registry: "1166180-16",
  chamber: "Cámara de Comercio de Cali",
  registeredAt: "2022-09-26",
  renewedAt: "2025-03-27",
  niif: "Grupo III",
  address: "CRA 41 #30C-16",
  city: "Cali, Valle del Cauca",
  country: "Colombia",
  email: "capstudio.col@gmail.com",
  phones: ["+57 312 770 0659", "+57 316 331 1197", "+57 322 560 2412"],
  year: 2026,
  legalUpdated: "2026-06-01",
};
